<template>
  <div class="import-user-dialog">
    <div class="import-user-dialog-content">
      <div class="import-user-dialog-content-header">
        <p class="import-user-dialog-content-header-title">批量导入设备</p>
        <img
          class="import-user-dialog-content-header-close"
          src="@imgs/close-card.png"
          @click="onCloseClick"
        />
      </div>
      <div class="import-user-dialog-content-body"
      v-loading="loading"
      :element-loading-text="loadingText"
      >
        <div class="import-user-dialog-content-body-upload">
          <input
            type="file"
            ref="fileInput"
            accept=".xlsx,.xls"
            style="display: none"
            @change="onFileChange"
          />
          <button
            class="import-user-dialog-content-body-upload-btn"
            @click="onUploadClick"
          >
            选择Excel文件
          </button>
          <p class="import-user-dialog-content-body-upload-tip">
            支持.xlsx、.xls格式文件
          </p>
        </div>
        <div class="import-user-dialog-content-body-template">
          <button
            class="import-user-dialog-content-body-template-btn"
            @click="onDownloadTemplateClick"
          >
            下载Excel模板
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ImportFileDialog",
  data() {
    return {
      file: null,
      loading: false,
      loadingText: '上传中'
    };
  },
  methods: {
    onCloseClick() {
      this.$emit("onCloseClick");
    },
    onUploadClick() {
      this.$refs.fileInput.click();
    },
    onFileChange(e) {
      const file = e.target.files[0];
      if (!file) return;
      
      if (!file.name.match(/\.(xlsx|xls)$/)) {
        this.$toast.showRed("请上传Excel文件");
        return;
      }

      this.file = file;
      this.uploadFile();
    },
    async uploadFile() {
      if (!this.file) return;

      const formData = new FormData();
      formData.append("file", this.file);

      try {
        await this.$api.uploadDeviceByExcel(
          formData,
          (progressEvent) => {
            console.log(progressEvent)
            const progress = Math.round(
              (progressEvent.loaded * 100) / progressEvent.total
            );
            // 这里可以添加进度条显示
            if (progress <= 100) {
              this.loading = true
              this.loadingText = `上传进度: ${progress}%`
            } else { 
              this.loading = false
              this.loadingText = "上传中"
            }
          }
        );
        this.$toast.showGreen("导入成功");
        this.onCloseClick();
        this.$emit("onImportSuccess");
      } catch (error) {
        this.$toast.showRed(error);
      }
    },
    onDownloadTemplateClick() {
      // TODO: 替换为实际的设备导入模板链接
      window.open("https://oss.bajiesleep.com/%E8%AE%BE%E5%A4%87%E6%A1%A3%E6%A1%88%E6%95%B0%E6%8D%AE%E5%85%A5%E5%BA%93.xlsx ", '_blank');
    },
   
  },
};
</script>

<style lang="scss" scoped>
.import-user-dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;

  &-content {
    width: rem(400);
    background-color: white;
    border-radius: rem(4);
    padding: rem(20);

    &-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: rem(20);

      &-title {
        font-size: rem(16);
        color: #333;
      }

      &-close {
        width: rem(20);
        height: rem(20);
        cursor: pointer;
      }
    }

    &-body {
      &-upload {
        display: flex;
        flex-direction: column;
        align-items: center;
        margin-bottom: rem(20);

        &-btn {
          width: rem(200);
          height: rem(40);
          background-color: #325fac;
          color: white;
          border-radius: rem(4);
          margin-bottom: rem(10);
        }

        &-tip {
          font-size: rem(12);
          color: #999;
        }
      }

      &-template {
        display: flex;
        justify-content: center;

        &-btn {
          width: rem(200);
          height: rem(40);
          background-color: #f5f5f5;
          color: #666;
          border-radius: rem(4);
        }
      }
    }
  }
}
</style> 